<section width="100%">
  <div class="loader">
    <div class="loader-box">
    Exportando relatórios das obras.<br /> Isso pode levar alguns segundos.
      <img
        width="120"
        height="120"
        loading="lazy"
        class="img-fluid"
        src="{{
          BASE_IMG_URL
        }}assets/img/loader-metrics.gif"
        alt="Carregando"
      />
    </div>
  </div>
</section>
